import YouTubePlayer from 'youtube-player';
class IframeYoutube extends HTMLElement {
  constructor() {
    self = super();
    // Always call super first in constructor
    // Return value from super() is a reference to this element

    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = 'https://img.youtube.com/vi/' + this.videoId + '/maxresdefault.jpg'
    this.playStatus = 0
    this.posterMarkup = `<div class="iframe__poster figure figure-gradient">
      <img
        src="${this.posterUrl}"
        width="1280"
        height="720"
        alt="Poster"
        class="iframe__img"
        loading="lazy">
    </div>`;

    // Create a shadow root
    // const shadow = this.attachShadow({mode: 'open'});
    
    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)

    this.appendChild(iframeContainer);

    this.player = YouTubePlayer(`player-${this.videoKey}`, {
      videoId: this.videoId
    });
    
    this.player.getDuration().then( duration => {
      const durationEl = document.querySelector(`[data-video-duration="${this.videoKey}"]`);
      if (durationEl) {
        durationEl.innerText =  (duration / 60).toFixed(2).replace('.', ':')
      }
    })
   

    this.playButton = document.querySelector(`[aria-controls="${this.videoKey}"]`);
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      
      this.playStatus === 1 ? this.player.pauseVideo() : this.player.playVideo() 

    })

    this.player.on('stateChange', (evt) => {
      this.playStatus = evt.data
      this.playButton.classList.toggle('play--paused', this.playStatus !== 2)

      if (evt.data === 0) {
        this.poster.classList.remove("iframe__poster--playing")
      }
    })
  
    this.calculateSize(this.posterUrl)
      .then(data => {
        if (data.width === 120 && data.height === 90) {
          iframeContainer.querySelector(".iframe__img").src = this.defaultCover
        }
      })
      .catch((error) => {
        console.error(error)
      })
  
  }
  
  calculateSize(url) {
    return new Promise(function(resolve, reject) {
      const image = document.createElement('img');
      image.addEventListener('load', function(e) {
        resolve({
          width: e.target.width,
          height: e.target.height,
        });
      });
      
      image.addEventListener('error', function() {
        reject('error');
      });
      
      image.src = url;
    });
  }
}

export default IframeYoutube
